var Ractive = require('ractive');
var component = module;

	component.exports = {
		onrender: function (options) {
			var self = this;

			if (Global.Callbacks['menu']) {
				Global.Callbacks['menu'].fire('doListCaption', "Početna");
			}			
			self.on('doRefresh', function (e) {
				self.cmd.Data(self, { Name: "Menu", Payload: {} }, function (oData) {
					if (oData) {
						if (oData.Status) {
							self.set("CacheData.Menu", oData.Data);
							var fMenuMeta = {};
							var fMenuMetaCount = 0;
							for (i = 0; i < oData.Data.length; i++) {
								for (j = 0; j < oData.Data[i].Items.length; j++) {
									fMenuMetaCount++;
									fMenuMeta[oData.Data[i].Items[j].UID] = {
										MenuCaption: oData.Data[i].Items[j].Caption,
										Caption: oData.Data[i].Items[j].Caption
									};
								}
							}
							if (fMenuMetaCount == 0) {
								self.set('NoData', true);
							} else {
								self.set('NoData', false);
							}
							Window.nteforms = fMenuMeta;
						} else {
							toastr.error("Error", oData.Error);
						}
					}
				});
			});
			self.on('doLogout', function () {
				self.cmd.Logout(self, function (oData) {
					if (oData.Status) {
						setTimeout(function () {
							window.location.href = "/";
						}, 800);
					}
				});
			});
			self.fire('doRefresh');
		},
		data: function () {
			return {
				Info: {},
				Data: [],
				Msgs: [],
				ErrorMessage: "",
				Lng: SiteLng
			}
		}
	}

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"class",f:"container-fluid",t:13}],f:[{p:[2,3,33],t:7,e:"div",m:[{n:"class",f:"page-content",t:13}],f:[{p:[3,3,63],t:7,e:"div",m:[{n:"class",f:"d-flex align-items-center justify-content-between page-header-breadcrumb flex-wrap gap-2",t:13}],f:[{p:[4,4,170],t:7,e:"div",m:[{n:"style",f:"height: 30px;",t:13}]}," ",{p:[6,4,210],t:7,e:"div",m:[{n:"class",f:"nte-menu",t:13}],f:[{t:4,f:[{p:[8,5,265],t:7,e:"div",m:[{n:"class",f:"card custom-card",t:13}],f:[{p:[9,6,302],t:7,e:"div",m:[{n:"class",f:"card-header",t:13}],f:[{p:[10,7,335],t:7,e:"div",m:[{n:"class",f:"card-title text-uppercase",t:13}],f:[" ",{t:3,r:".Caption",p:[10,52,380]}]}]}," ",{p:[12,6,420],t:7,e:"div",m:[{n:"class",f:"card-body",t:13}],f:[{p:[13,7,451],t:7,e:"div",m:[{n:"class",f:"row",t:13}],f:[{t:4,f:[{t:4,f:[{p:[16,8,526],t:7,e:"div",m:[{n:"class",f:"col-xs-12 col-12",t:13}],f:[{t:3,r:".Caption",p:[17,9,566]}]}," ",{t:4,f:[{p:[20,8,627],t:7,e:"a",m:[{n:"class",f:"btn btn-info col-lg-2 col-sm-3 col-xs-12 col-12 nte-menu-btn",t:13},{n:"href",f:[{t:2,x:{r:["format",".UID"],s:"_0.Href(\"list\",_1)"},p:[21,15,714]}],t:13}],f:[{t:3,r:".Caption",p:[21,46,745]}]}],i:"mi",r:".Items",p:[19,8,604]}],n:50,x:{r:[".Type"],s:"_0==0"},p:[15,8,500]}," ",{t:4,f:[{p:[25,8,828],t:7,e:"a",m:[{n:"class",f:"btn btn-info col-lg-2 col-sm-3 col-xs-12 col-12 nte-menu-btn",t:13},{n:"href",f:[{t:2,x:{r:["format",".UID"],s:"_0.Href(\"list\",_1)"},p:[26,15,915]}],t:13}],f:[{t:3,r:".Caption",p:[26,46,946]}]}],n:50,x:{r:[".Type"],s:"_0==1"},p:[24,8,802]}],i:"mi",r:".Items",p:[14,8,477]}]}]}]}],i:"m",r:"CacheData.Menu",p:[7,5,238]}]}," ",{t:4,f:[{p:[35,4,1084],t:7,e:"div",m:[{n:"class",f:"alert alert-info",t:13}],f:[{p:[36,5,1120],t:7,e:"br"}," ",{p:[37,5,1130],t:7,e:"h4",f:["Vi ",{p:[37,12,1137],t:7,e:"strong",f:[{t:3,r:"session.UserName",p:[37,20,1145]}]},", nemate privilegije!"]}," ",{p:[38,5,1208],t:7,e:"br"}," ",{t:4,f:[{p:[40,5,1243],t:7,e:"a",m:[{n:"href",f:[{t:2,r:"LinkManual",p:[40,14,1252]}],t:13},{n:"target",f:"_blank",t:13},{n:"title",f:"Vidite Uputstvo",t:13}],f:["Uputstvo"]},"  "],n:50,r:"LinkManual",p:[39,5,1218]}," ",{t:4,f:[{p:[43,5,1374],t:7,e:"a",m:[{n:"href",f:[{t:2,r:"LinkHelp",p:[43,14,1383]}],t:13},{n:"target",f:"_blank",t:13},{n:"title",f:"Vidite Pomoć",t:13}],f:["Pomoć"]}," "],n:50,r:"LinkHelp",p:[42,5,1351]}]}],n:50,r:"NoData",p:[34,4,1064]}," ",{p:[48,4,1492],t:7,e:"div",m:[{n:"style",f:"height: 50px;",t:13}]}," ",{p:[50,4,1532],t:7,e:"div",m:[{n:"class",f:"card custom-card",t:13}],f:[{p:[51,5,1568],t:7,e:"div",m:[{n:"class",f:"card-header",t:13}],f:[{p:[52,6,1600],t:7,e:"div",m:[{n:"class",f:"card-title",t:13}],f:["Profil"]}]}," ",{p:[54,5,1654],t:7,e:"div",m:[{n:"class",f:"card-body",t:13}],f:[{p:[55,6,1684],t:7,e:"a",m:[{n:"class",f:[{t:3,r:"Lng.Page.404.Home.Class",p:[55,16,1694]}],t:13},{n:"href",f:"#firma",t:13}],f:["FIRMA"]},"   ",{p:[56,6,1767],t:7,e:"a",m:[{n:"class",f:[{t:3,r:"Lng.Page.404.Back.Class",p:[56,16,1777]}],t:13},{n:"href",f:"#profil",t:13}],f:["PROFIL"]},"     ",{p:[57,6,1864],t:7,e:"button",m:[{n:"class",f:[{t:2,r:"Lng.Page.Access.Logout.Class",p:[57,21,1879]}," ex-action"],t:13},{n:"click",f:{x:{r:["@this"],s:"[_0.fire(\"doLogout\")]"}},t:70}],f:[{t:3,r:"Lng.Page.Access.Logout.Text",p:[57,99,1957]}]}]}]}," ",{p:[61,4,2029],t:7,e:"div",m:[{n:"style",f:"height: 50px;",t:13}]}]}]}]}],e:{"_0.Href(\"list\",_1)":function (_0,_1){return(_0.Href("list",_1));},"_0==0":function (_0){return(_0==0);},"_0==1":function (_0){return(_0==1);},"[_0.fire(\"doLogout\")]":function (_0){return([_0.fire("doLogout")]);}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/Menu.html
// module id = 28
// module chunks = 0